import script from "./RoomBoxSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./RoomBoxSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./RoomBoxSkeleton.vue?vue&type=style&index=0&id=40f34973&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-melindacvc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40f34973"]])

export default __exports__